export default __webpack_public_path__ + "static/media/remark_drop.cbf99d2e.svg";